import React from 'react';
import { MenuItem as MuiMenuItem } from '@mui/material';

interface CustomMenuItemProps {
  label?: string;
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLLIElement>) => void;
  className?: string;
}

const CustomMenuItem: React.FC<CustomMenuItemProps> = ({
  label,
  children,
  onClick,
  className,
  ...props
}) => {
  const handleClick = (event: React.MouseEvent<HTMLLIElement>) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <MuiMenuItem onClick={handleClick} className={className} {...props}>
      {label}
      {children}
    </MuiMenuItem>
  );
};

export default CustomMenuItem;
